/**
 * "h:mm:ss AM" for a card or row timestamp. Live alerts carry UTC with a "Z";
 * a timestamp without a zone (a restored row, say) is read as UTC too, so a
 * naive string gets a "Z" before parsing. Returns '' for anything unparseable rather than "Invalid Date".
 */
export function formatClockTime(timestamp?: string): string {
  if (!timestamp) return '';
  const hasZone = timestamp.endsWith('Z') || timestamp.includes('+') || timestamp.includes('-', 10);
  const parsed = new Date(hasZone ? timestamp : `${timestamp}Z`);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toLocaleTimeString(undefined, {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
}
